import gameIds from 'a/hub/data/GameIds';

export const GAME_ID = gameIds.SILABALON_LA_COPA;
export const CHARACTERS_PER_LEVEL = 15;
export const MASTERY_THRESHOLD = 0.86;
export const DELAY_BEFORE_DISAPPEARING = 300;
export const DELAY_FOR_CHARACTER_TO_APPEAR = 500;
export const FPS = 30;

// Game screens
export const SCREENS = {
  PROGRESS: 'PROGRESS',
  ONBOARDING_VIEW: 'ONBOARDING_VIEW',
  REPEAT_ONBOARDING: 'REPEAT_ONBOARDING',
  STANDARD_VIEW: 'STANDARD_VIEW',
  LOADING: 'LOADING',
};

export const REDUX_ACTIONS = {
  CHANGE_SCREEN: 'CHANGE_SCREEN',
  SAVE_SCREEN_COORDINATES: 'SAVE_SCREEN_COORDINATES',
  LOAD_CURRICULUM: 'LOAD_CURRICULUM',
  INIT_CURRICULUM: 'INIT_CURRICULUM',
  INCREASE_PROGRESS: 'INCREASE_PROGRESS',
  START_ROUND: 'START_ROUND',
  COMPLETE_ROUND: 'COMPLETE_ROUND',
  INCREMENT_CORRECT_COUNT: 'INCREMENT_CORRECT_COUNT',
  MARK_ONBOARDING_SEEN: 'MARK_ONBOARDING_SEEN',
  MARK_PRACTICE_ONBOARDING_SEEN: 'MARK_PRACTICE_ONBOARDING_SEEN',
  QUICK_ROUND: 'QUICK_ROUND',
};

export const CHARACTER_STATES = {
  READY: 'ready',
  RUNNING: 'running',
  WAVING: 'waving',
  JUMPING: 'jumping',
};

export const CHARACTER_ACTIONS = {
  IDLE: 'idle',
  ASKING: 'asking',
  FRUSTRATING: 'frustrating',
  KICKING: 'kicking',
};

export const TRANSITIONS = {
  READY_TO_RUNNING: 1,
  RUNNING_TO_READY: 2,
  RUNNING_TO_WAVING: 3,
  WAVING_TO_READY: 4,
  WAVING_TO_JUMPING: 5,
  JUMPING_TO_READY: 6,
};

export const FRAMES = {
  [CHARACTER_STATES.READY]: {
    [CHARACTER_ACTIONS.IDLE]: [0, 81], // 82 frames
    [CHARACTER_ACTIONS.ASKING]: [82, 125], // 44 frames
    [CHARACTER_ACTIONS.FRUSTRATING]: [126, 164], // 39 frames
    [CHARACTER_ACTIONS.KICKING]: [165, 226],
  },
  [CHARACTER_STATES.RUNNING]: { // Equivalent to spit
    [CHARACTER_ACTIONS.IDLE]: [244, 309], // 65 frames
    [CHARACTER_ACTIONS.ASKING]: [310, 353], // 44 frames
    [CHARACTER_ACTIONS.FRUSTRATING]: [354, 392], // 38 frames
  },
  [CHARACTER_STATES.WAVING]: { // Equivalent to barf
    [CHARACTER_ACTIONS.IDLE]: [425, 490], // 65 frames
    [CHARACTER_ACTIONS.ASKING]: [491, 535], // 44 frames
    [CHARACTER_ACTIONS.FRUSTRATING]: [536, 573], // 37 frames
  },
  [CHARACTER_STATES.JUMPING]: {
    [CHARACTER_ACTIONS.IDLE]: [606, 671], // 65 frames
    [CHARACTER_ACTIONS.ASKING]: [672, 716], // 44 frames
    [CHARACTER_ACTIONS.FRUSTRATING]: [717, 754], // 37 frames
  },
  transitions: {
    [TRANSITIONS.READY_TO_RUNNING]: [227, 243],
    [TRANSITIONS.RUNNING_TO_READY]: [393, 408],
    [TRANSITIONS.RUNNING_TO_WAVING]: [409, 424],
    [TRANSITIONS.WAVING_TO_READY]: [574, 589],
    [TRANSITIONS.WAVING_TO_JUMPING]: [590, 605],
    [TRANSITIONS.JUMPING_TO_READY]: [755, 770],
  },
};

export const CHARACTER_TYPE = {
  DOG: 'dog',
  CHEETAH: 'cheetah',
  KOALA: 'koala',
};

export const AVAILABLE_CHARACTERS = Object.values(CHARACTER_TYPE);
